import { makeAutoObservable } from "mobx";

import type { RootStore } from "@/store/RootStore";

export class ImportFromOverleafDialogStore {
  rootStore: RootStore;

  isOpen = false;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  open() {
    this.isOpen = true;
  }

  close() {
    this.isOpen = false;
  }

  uploadFiles = async (files: File[]): Promise<string | undefined> => {
    const target = this.rootStore.documentTree.getTargetFolderAndIndex();
    if (files.length === 0 || !target) {
      return;
    }

    const firstDocId = await this.rootStore.documentTree.enqueueFilesForUpload(
      files,
      target.folder.uid,
      target.index,
    );
    return firstDocId;
  };
}
